import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Placebar from "../../components/Placebar";
import {UserAccountContext} from "../../contexts/userAccount";
import "./style.scss";

export default class NavBarContent extends React.Component {
  render() {
    return (
      <UserAccountContext.Provider value={{user: this.props.currentUser}}>
        <AppBar id="navContainer">
          <Toolbar className="mainAppBar" disableGutters={true}>
            <Placebar {...this.props} />
          </Toolbar>
        </AppBar>
      </UserAccountContext.Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavBar/index.jsx